<template>
    <div class="page_ page_custome_">
       <navbar />
        <div class="content_ w1200_">
            <div class="breadcrumb_">首页 > 产品列表</div>
            <div class="radio_wrap_">
                <div>
                    <i v-if="!hideIconLeft && productTags && productTags.length > 6" @click="handleScrollLeft" class="prev_"></i>
                    <div ref="ptWrap_" class="pt_wrap_">
                        <a-radio-group style="transation: all 1s easeOut;" :style="`transform: translateX(${tabTranslateX}px);`" @change="handleProductTagChange" v-model="currentProductTag" buttonStyle="solid">
                            <a-radio-button v-for="item in productTags" :value="item.id">{{item.name}}</a-radio-button>
                        </a-radio-group>
                    </div>
                    <i v-if="!hideIconRight && productTags && productTags.length > 6" @click="handleScrollRight" class="next_"></i>
                </div>
                <div class="search_">
                    <a-input-search
                        placeholder="安联“申根之王”欧洲旅行保险"
                        @search="onSearch"
                        @change="onSearchChange"
                        @blur="onSearchBlur"
                        size="large"
                        v-model="searchKeyword"
                    >
                        <a-button slot="enterButton" type="primary"><a-icon type="search"></a-icon>搜索</a-button>
                    </a-input-search>
                    <ul role="listbox" tabindex="0" v-if="showKeywordList" class="keyword_list_">
                        <li role="option" @click="searchKeyword=item" v-for="item in keywordList">{{item}}</li>
                    </ul>
                </div>
            </div>

            <div class="options_container_">
                <div class="options_item_">
                    <div class="type_title_">保险公司</div>
                    <div :style="'height:' + (expandObj['1'] ? 'auto;' : '20px;')" class="labels_wrap_">
                        <label @click="handleLabelChange('company', '')" :class="{'active_': selectedLabels['company'] == ''}">不限</label>
                        <label @click="handleLabelChange('company', item.id)" :class="{'active_': selectedLabels['company'] == item.id}" v-for="item in companys" :key="item.id">{{item.name}}</label>
                    </div>
                    <div @click="expandObj['1']=!expandObj['1']" class="expand_all_ active_">{{expandObj['1'] ? '收起全部' : '展开全部'}} </div>
                </div>
                <!-- <div class="options_item_">
                    <div class="type_title_">产品分类</div>
                    <div class="labels_wrap_">
                        <label>不限</label>
                        <label v-for="item in productTags" :key="item.id">{{item.name}}</label>
                    </div>
                    <div @click="expandObj['1']=!expandObj['1']" class="expand_all_ active_">{{expandObj['1'] ? '收起全部' : '展开全部'}} </div>
                </div> -->
                <div class="options_item_">
                    <div class="type_title_">标签分类</div>
                    <div :style="'height:' + (expandObj['2'] ? 'auto;' : '20px;')" class="labels_wrap_">
                        <label @click="handleLabelChange('label', '')" :class="{'active_': selectedLabels['label'] == ''}">不限</label>
                        <label @click="handleLabelChange('label', item.id)" :class="{'active_': selectedLabels['label'] == item.id}" v-for="item in labels" :key="item.id">{{item.name}}</label>
                    </div>
                    <div @click="expandObj['2']=!expandObj['2']" class="expand_all_ active_">{{expandObj['2'] ? '收起全部' : '展开全部'}} </div>
                </div>
            </div>

            <div class="product_list_">
                <ul v-if="productList && productList.length > 0">
                    <li :key="item.productCode" v-for="item in productList">
                        <div class="left_">
                            <img :src="item.detailImgUrl"/>
                        </div>
                        <div class="right_wrap_">
                            <div class="company_">{{item.underCompany}}</div>
                            <div class="title_">{{item.productName}}</div>
                            <div class="desc_">{{item.productSale || '----'}}</div>
                            <div class="labels_"><label v-for="tag in item.productTag">{{tag}}</label></div>
                            <div class="price_wrap_">
                                产品报价 <label class="price_"><span class="num_">{{item.price}}</span> 元起</label>
                                <a-button @click="handleJumpDetail(item.productCode)" class="pos_r_" size="large" type="primary">查看详情</a-button>
                            </div>
                        </div>
                    </li>
                </ul>
                <div v-else-if="productList && productList.length == 0" class="empty_">
                    <img src="../assets/index.png"/>
                    未查询到相关产品
                </div>
                <div v-if="productList && productList.length > 0" class="page_wrap_">
                    <a-pagination @change="handlePageChange" :total="pTotal" :itemRender="itemRender" />
                </div>
            </div>
            <!-- <div class="footer1_">
                <img v-if="companyInfo.pcPicture" :src="companyInfo.pcPicture"/>
            </div> -->
            <!-- <div class="footer2_">
                <ul>
                    <li>
                        <img src="logo_zql.png"/>
                    </li>
                    <li class="tc_">
                        <div class="tel_">400-600-6666</div>
                        <div class="tel_name_">全国统一咨询热线</div>
                    </li>
                    <li>
                        <img src=""/>
                    </li>
                </ul>
            </div> -->
            <!-- <div v-if="companyInfo.corePcstoreLinks" class="footer3_">
                <a v-for="(item, index) in companyInfo.corePcstoreLinks" :key="index" target="_blank" :href="item.url" >{{item.name}}</a>
            </div> -->
            <!-- <div class="footer4_">
                <img v-if="companyInfo.pcFooter && companyInfo.pcFooter.substr(0,4) == 'http'" :src="companyInfo.pcFooter"/>
                <div v-else v-html="companyInfo.pcFooter"></div>
            </div> -->
            <!-- <div class="footer5_">
                <div class="cr1_">
                    中青旅控股股份有限公司 © 2019-2029 yutaieb.com All Rights Reserved 京ICP备16001338号-6
                </div>
                <div class="cr2_"></div>
            </div> -->
        </div>
         <footbar></footbar>
    </div>
</template>
<style lang="scss" scoped>
    .footer4_ {
        white-space: pre-wrap;
        & > img {
            width: 100%;
            height: auto;
        }
    }
    .footer1_ {
        img {
            width: 100%;
            height: auto;
        }
    }
    .footer5_ {
        text-align: center;
        .cr1_ {
            color: #666;
        }
        .cr2_ {
            color: #999;
        }
    }
    .footer2_ {
        margin: 31px 0 39px;
        ul {
            display: flex;
            li {
                height: 86px;
                flex: 1;
                border-right: 1px solid rgba(0,0,0,0.1);
                &.tc_ {
                    text-align: center;
                }
                .tel_ {
                    font-size:30px;
                    font-weight:bold;
                    color:rgba(245,105,44,1);
                    margin-top: 14px;
                }
                .tel_name_ {
                    font-size:16px;
                    font-weight:400;
                    color:rgba(0,0,0,1);
                    margin-top: 18px;
                }
            }
        }
    }
    .footer3_ {
        display: flex;
        justify-content: space-between;
        background: #eee;
        color: #333;
        padding: 6px 100px;
    }
    ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }
    .header {
        padding-top: 21px;
        border-bottom: 1px solid #F5692C;
    }
    .w1200_ {
        width: 1200px;
        margin: 0 auto;
        .logo_ {
            width: auto;
            height: 56px;
            margin-bottom: 21px;
        }
        .keyword_list_ {
            position: absolute;
            left: 20px;
            right: 20px;
            top: 50px;
            line-height: 28px;
            border: 1px solid #F5692C;
            border-top: none;
            min-height: 200px;
            max-height: 300px;
            overflow-y: auto;
            background: #fff;
            font-size: 16px;
            li {
                padding-left: 20px;
                cursor: pointer;
                &:hover {
                    background: #F5692C;
                    color: #fff;
                }
            }
        }
        .active_ {
            color: #F5692C !important;
            font-size: 14px;
        }
        &.content_ {
            line-height: 1;
            .product_list_ {
                .empty_ {
                    text-align: center;
                    min-height: 300px;
                    img {
                        display: block;
                        margin: 0 auto;
                    }
                }
                li {
                    position: relative;
                    border: 1px solid #E5E5E5;
                    margin-bottom: 29px;
                    &:hover {
                        border: 1px solid #F5692C;
                    }
                }
                .left_ {
                    width: 330px;
                    height: 204px;
                    display: inline-block;
                    background: #eee;
                    vertical-align: top;
                    img {
                        width: 100%;
                        height: 204px;
                        object-fit:cover;
                    }
                }
                .right_wrap_ {
                    display: inline-block;
                    padding: 19px 29px;
                    .company_ {
                        position: absolute;
                        top: 23px;
                        right: 42px;
                        font-size: 14px;
                        color: #999;
                    }
                }
                .price_wrap_ {
                    font-size: 14px;
                    color: #333;
                    .price_ {
                        margin-left: 8px;
                        font-size:14px;
                        font-weight:bold;
                        color:rgba(255,39,39,1);
                        .num_ {
                            font-size:28px;
                        }
                    }
                    .pos_r_ {
                        position: absolute;
                        right: 41px;
                        bottom: 21px;
                    }
                }
                .title_ {
                    font-size:28px;
                    font-weight:bold;
                    color:rgba(51,51,51,1);
                    margin-bottom: 18px;
                }
                .desc_ {
                    font-size:14px;
                    font-weight:400;
                    color:rgba(102,102,102,1);
                    line-height: 20px;
                    margin-bottom: 14px;
                    white-space: pre-wrap;
                }
                .labels_ {
                    margin-bottom: 19px;
                    label {
                        border: 1px solid #999999;
                        padding: 6px 10px;
                        font-size: 14px;
                        color: #999;
                        margin-right: 19px;
                        display: inline-block;
                    }
                }
            }
            .options_container_ {
                margin-top: 40px;
            }
            .options_item_ {
                display: flex;
                margin-bottom: 40px;
                font-size:16px;

                .type_title_ {
                    font-weight:bold;
                    color:rgba(51,51,51,1);
                    margin-right: 39px;
                }
                .labels_wrap_ {
                    flex: 1;
                    display: flex;
                    flex-flow: wrap;
                    overflow: hidden;
                    label {
                        margin-right: 39px;
                        margin-bottom: 16px;
                        font-weight:400;
                        font-size: 14px;
                        color: #666666;
                        cursor: pointer;
                        &:hover {
                            color: #F5692C;
                        }
                    }
                }
                .expand_all_ {
                    cursor: pointer;
                    &::after {
                        content: '';
                        display: inline-block;
                        width: 10px;
                        height: 10px;
                        border-top: 1px solid #F5692C;
                        border-right: 1px solid #F5692C;
                        transform: rotateZ(45deg);
                    }
                }
            }
            .breadcrumb_ {
                margin: 54px 0 20px;
            }
            .pt_wrap_ {
                white-space: nowrap;
                overflow: hidden;
            }
            .radio_wrap_ {
                border-bottom: 3px solid #F5692C;
                position: relative;
                .prev_ {
                    position: absolute;
                    left: -20px;
                    top: 25px;
                    width: 13px;
                    height: 13px;
                    border-top: 3px solid #F5692C;
                    border-left: 3px solid #F5692C;
                    transform: rotate(-45deg);
                    cursor: pointer;
                }
                .next_ {
                    position: absolute;
                    right: -20px;
                    top: 25px;
                    width: 13px;
                    height: 13px;
                    border-top: 3px solid #F5692C;
                    border-right: 3px solid #F5692C;
                    transform: rotate(45deg);
                    cursor: pointer;
                }
                .search_ {
                   position: absolute;
                   right: 0;
                   top: -56px; 
                }
            }
        }
        .tel_label_ {
            font-size:16px;
            font-weight:400;
            color:rgba(0,0,0,1);
        }
        .tel_val_ {
            font-size:30px;
            font-weight:bold;
            color:rgba(245,105,44,1);
        }
    }
</style>
<script>
import navbar from './wxmall/components/navbar'
import footbar from './wxmall/components/footbar'
import api from '@/utils/api'
import Storage from '@/utils/storage'
const companys = []
const labels = []
const productTags = []
const KEY = '_history_search_keyword'

export default {
    data () {
        return {
            pTotal: 1,
            hideIconLeft: true,
            hideIconRight: '',
            tabTranslateX: 0,
            currentProductTag: 1,
            searchKeyword: '',
            keywordList: [],
            productList: null,
            labels,
            productTags,
            companyInfo: {},
            expandObj: {
                '1': false,
                '2': false,
                '3': false
            },
            selectedLabels: {
                company: '',
                label: ''
            },
            companys,
            links: [{
                name: '关于我们',
                url: ''
            }, {
                name: '联系我们',
                url: ''
            }, {
                name: '门市地址',
                url: ''
            }, {
                name: '人才招聘',
                url: ''
            }, {
                name: '法律声明',
                url: ''
            }, {
                name: '隐私保护',
                url: ''
            }, ],
            showKeywordList: false
        }
    },
    components: {
        navbar,footbar
    },
    mounted () {
        const { sign } = this.$route.query
        this.resolveSign(sign).then(() => {
            this.fetchStore()
        })
    },
    methods: {
      resolveSign (sign) {
        return api.resolveSign({
          sign
        }).then(res => res.data).then(data => {
            this._userId = data.content
        })
      },
      handleJumpDetail (productCode) {
        this._jumpUrlCache = this._jumpUrlCache || {}
        let url = this._jumpUrlCache[productCode]
        if (url) {
            window.open(url)
        }
        this.generateUrl(productCode).then(url => {
            this._jumpUrlCache[productCode] = url
            window.open(url)
        })
      },
      handleScrollLeft () {
        this.tabTranslateX += 170
        if (this.tabTranslateX >= 0) {
            this.hideIconLeft = true
        }
        this.hideIconRight = false
      },
      handleScrollRight () {
        this.tabTranslateX -= 170
        const w = this.$refs['ptWrap_'].children[0].offsetWidth
        if (this.tabTranslateX < 1200 - w) {
            this.hideIconRight = true
        }
        this.hideIconLeft = false
        console.log(el, 'handleScrollRight -> ')
      },
      handleProductTagChange () {
        console.log('handleProductTagChange -> ', this.currentProductTag)
        this.fetchProducts()
        this.fetchProductLablesByTag()
      },
      handleLabelChange(key, val) {
        this.selectedLabels[key] = val
        this.fetchProducts()
      },
      onSearchBlur() {
        let st = setTimeout(() => {
            this.showKeywordList=false
            clearTimeout(st)
        }, 300);
      },
      onSearchChange (e) {
        console.log('onSearchChange -> ', e)
        if (!this.showKeywordList) {
            this.keywordList = Storage.get(KEY)
            this.showKeywordList = true
        }
      },
      generateUrl (productCode) {
        return api.generateUrl({
          userId: this._userId,
          productCode
        }).then(res => res.data).then(data => {
            this.jumpUrl = data.content
            return data.content
        })
      },
      fetchStore () {
        api.queryStore({userId: this._userId}).then(res => res.data).then(data => {
            const { coreStoreDto, lables, productTags, companys} = data.content
            this.companyInfo = coreStoreDto
            this.companys = companys
            // this.labels = lables
            this.currentProductTag = productTags && productTags[0].id
            this.productTags = productTags || []
            if (this.currentProductTag) {
                this.fetchProducts()
                this.fetchProductLablesByTag()
            }
        })
      },
      fetchProductLablesByTag () {
        api.queryProductLablesByTag({
            productTagId: this.currentProductTag,
            userId: this._userId
        }).then(res => res.data).then(data => {
            this.labels = data.content
        })
      },
      fetchProducts () {
        const params = {
            pageNum: this._page || 1,
            pageSize: 10,
            userId: this._userId.toString(),
            productTag: this.currentProductTag
        }
        if (this.selectedLabels.company) {
            params['companyId'] = this.selectedLabels.company
        }
        if (this.selectedLabels.label) {
            params['lableId'] = this.selectedLabels.label
        }
        if (this._productName) {
            params['productName'] = this._productName
        }
        api.queryProducts(params).then(res => res.data).then(data => {
            this.productList = data.content.productResDtos
            this.pTotal = data.content.totalCount || this.productList.length
        }).catch(() => {
            this.productList = []
            this.pTotal = 0
        })
      },
      onSearch (keyword) {
        console.log('onSearch -> ', keyword)
        const arr = Storage.addItem(KEY, keyword)
        this._productName = keyword
        this.fetchProducts()
        console.log(Storage.get(KEY), '保存的搜索数据')
      },
      handlePageChange (page) {
        console.log('page -> ', page)
        this._page = page
        this.fetchProducts()
      },
      itemRender(current, type, originalElement) {
        if (type === 'prev') {
          return <a>上一页</a>;
        } else if (type === 'next') {
          return <a>下一页</a>;
        }
        return originalElement;
      },
    }
}
</script>